import { useCallback } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { IQuoteStats } from "../models/Quote";
import { DefaultResponseWithData } from "../models/system";
import apiConfig from "../utils/apiConfig";

export default function useQuotes(componentName = "useQuotes") {
  const { get } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();
  const quoteStatsQueryKey = ["quotes", "stats"];

  const quoteStats = useQuery({
    queryKey: quoteStatsQueryKey,
    queryFn: () => get<DefaultResponseWithData<IQuoteStats>>("/quote/stats"),
    staleTime: 1000 * 60 * 30, // 30 minutes
    refetchInterval: 1000 * 60 * 30, // 30 minutes
    refetchIntervalInBackground: true,
  });

  const invalidateQuoteStats = useCallback(
    () => queryClient.invalidateQueries({ queryKey: quoteStatsQueryKey }),
    [queryClient]
  );

  return {
    quoteStats,
    invalidateQuoteStats,
    quoteStatsQueryKey,
  };
}